import { BaseModel, BaseNomenclatorModel } from './base.model';

export class ProductPackingTypeModel extends BaseNomenclatorModel {
    uid: string;
    name: string;
}
